import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Button from "@shared/v2/Button";
import { Table, TBody, TD, TH, THead, TR } from "../../Reports/components/BusinessDashboard/Table/Table";

const UserTable = ({ currentSuperUserRole, onEditUser, users }) => {
  const [oktaStatuses, setOktaStatuses] = useState([]);

  useEffect(() => {
    if (users.length === 0) return;

    axios
      .get(`/support/accounts/${users[0].account_id}/users/okta_statuses`)
      .then((response) => {
        const tempOktaStatuses = {};

        users.forEach((user) => {
          const oktaStatus = response.data.users.find((os) => os.user_id === user.id);

          tempOktaStatuses[user.id] = oktaStatus;
        });

        setOktaStatuses(tempOktaStatuses);
      })
      .catch(console.log);
  }, []);

  const renderOktaStatus = (userId) => {
    if (!oktaStatuses) {
      return null;
    }

    const oktaStatus = oktaStatuses[userId];

    if (oktaStatus) {
      return (
        <span>
          {oktaStatus.okta_status && <a href={oktaStatus.admin_center_link}>{oktaStatus.okta_status}</a>}
          {!oktaStatus.okta_status && "not found"}
        </span>
      );
    }

    return <span>(loading)</span>;
  };

  return (
    <Table>
      <THead>
        <TR>
          <TH>Tools</TH>
          <TH>ID</TH>
          <TH>UUID</TH>
          <TH>First Name</TH>
          <TH>Last Name</TH>
          <TH>Email</TH>
          <TH>Active</TH>
          <TH>CRM Access</TH>
          <TH>Managed Phone</TH>
          <TH>Status</TH>
          <TH>Okta Status</TH>
          <TH>Type</TH>
          <TH>External</TH>
        </TR>
      </THead>
      <TBody>
        {users.map((user) => (
          <TR key={user.uuid} className="hover:tw-bg-gray-5 even:tw-bg-tinted-gray-25">
            <TD>
              <div className="tw-flex tw-gap-[4px]">
                <form action={`/super_users/${user.id}/become`} method="post">
                  <input type="hidden" name="become_user_email" value={user.email} />
                  <Button type="submit" size="medium">
                    Become
                  </Button>
                </form>
                {currentSuperUserRole === "place" ? null : (
                  <Button size="medium" schema="secondary" onClick={() => onEditUser(user)}>
                    Edit
                  </Button>
                )}
              </div>
            </TD>
            <TD>{user.id}</TD>
            <TD>{user.uuid}</TD>
            <TD>{user.person ? user.person.first_name : "MISSING PERSON"}</TD>
            <TD>{user.person ? user.person.last_name : "N/A"}</TD>
            <TD>{user.email}</TD>
            <TD>{user.active.toString()}</TD>
            <TD>{user?.crm_access.toString()}</TD>
            <TD>{user.managed_phone_number}</TD>
            <TD>{user.person ? user.person.status : "N/A"}</TD>
            <TD>{renderOktaStatus(user.id)}</TD>
            <TD>{user.person ? user.person.type_name : "N/A"}</TD>
            <TD>{user.external}</TD>
          </TR>
        ))}
      </TBody>
    </Table>
  );
};

const UserShape = PropTypes.shape({
  account_id: PropTypes.number,
});

UserTable.propTypes = {
  currentSuperUserRole: PropTypes.string.isRequired,
  onEditUser: PropTypes.func.isRequired,
  users: PropTypes.arrayOf(UserShape).isRequired,
};

export default UserTable;
